import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Pagination,
  BulkDeleteWithConfirmButton,
  AutocompleteArrayInput,
  NumberField,
  BulkActionsToolbar,
} from "react-admin";

import { getPageId } from "../../helpers/getPageId";

import CustomDateField from "../Common/CustomDateField";
import { EXPORT_STATUSES, PENDING } from "./Constant";
import DownloadField from "./DownloadField";
import UserField from "./UserField";
import ExportParamsField from "./ExportParamsField";

const defaultFilters = [
  <AutocompleteArrayInput
    source="status_in"
    label={`Status`}
    choices={EXPORT_STATUSES}
    alwaysOn
    //allowEmpty={false}
  />,
];

// const BulkActionButtons = (props) => (
//   <>
//     <BulkFbFollowUpMessageButton {...props} />
//     {/* Add the default bulk delete action */}
//     <CustomBulkDeleteButton {...props} />
//   </>
// );

// const WLHelp = () => (
//   <KbLinkButton
//     url={`https://learn.boxify.io/kb/08-4-21-feature-of-waitlists/`}
//   />
// );

const ExportBulkActionButtons = () => (
  <BulkActionsToolbar selectAllButton={false}>
    <BulkDeleteWithConfirmButton />
  </BulkActionsToolbar>
);

const ExportsList = (props) => {
  const pageId = getPageId();
  // const isEnterprisePlan = useIsEnterprisePlan();
  // const isBusinessPlan = useIsBusinessPlan();
  //   const { isMultiCurrency } = useAvailableCurrencies();
  // const isSmall = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <>
      <h5>Jobs will be deleted after 7 days from creation date.</h5>
      <List
        {...props}
        actions={false}
        // exporter={exporter}
        filter={{ page: pageId }}
        filters={defaultFilters}
        pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
        sort={{ field: "createdAt", order: "DESC" }}
      >
        <Datagrid
          isRowSelectable={({ createdAt }) => {
            const createdDate = new Date(createdAt);
            const now = new Date();
            const diffInMinutes = (now - createdDate) / (1000 * 60);
            // If createdAt is more than 10 minutes ago, return true to allow deletion, to handle stucked pending jobs
            return diffInMinutes > 10;
          }}
          bulkActionsToolbar={<ExportBulkActionButtons />}
        >
          <TextField source="_id" />
          <ExportParamsField source="params" />
          <NumberField source="recordCount" />
          <TextField source="status" />
          <DownloadField source="download" />
          <UserField source="username" />
          <CustomDateField source="createdAt" showTime />
          <CustomDateField source="updatedAt" showTime />
        </Datagrid>
      </List>
    </>
  );
};

export default ExportsList;
